import React from 'react'
import { SvgProps } from 'react-native-svg'

import { UserRole } from '@alucio/aws-beacon-amplify/src/models'

import HomeIcon from 'src/assets/icons/Home'
import LibraryIcon from 'src/assets/icons/Molecule'
import MyFoldersIcon from 'src/assets/icons/Folder'
import BookmarksIcon from 'src/assets/icons/Bookmarks'
import MeetingHistoryIcon from 'src/assets/icons/Calendar'
import LetterIcon from 'src/assets/icons/Letter'
import AnalyticsIcon from 'src/assets/icons/Analytics'
import AdminSettingsIcon from 'src/assets/icons/AdminSettings'
import { HubsIcon } from 'src/assets/icons/Hubs'

export const STANDARD_ROLES = [
  UserRole.TENANT_PUBLISHER,
  UserRole.TENANT_VIEWER,
];

export enum PAGES {
  CRM_INTEGRATION = 'CRM_INTEGRATION',
  SSO_OIDC_START = 'SSO_OIDC_START',
  SSO_OIDC_CALLBACK = 'SSO_OIDC_CALLBACK',
  HOME = 'HOME',
  PLAYGROUND = 'PLAYGROUND',
  EMAIL_TEMPLATES = 'EMAIL_TEMPLATES',
  PUBLISHER_DASHBOARD = 'PUBLISHER_DASHBOARD',
  TENANTS = 'TENANTS',
  LIBRARY = 'LIBRARY',
  BEACON_COPY_LINK = 'BEACON_COPY_LINK',
  BEACON_COPY_LINK_HOME = 'BEACON_COPY_LINK_HOME',
  BEACON_COPY_LINK_BOOKMARKS = 'BEACON_COPY_LINK_BOOKMARKS',
  BOOKMARKS = 'BOOKMARKS',
  MEETING_HISTORY = 'MEETING_HISTORY',
  MEETING_PRESENTATION = 'MEETING_PRESENTATION',
  MEETING_CONTENT = 'MEETING_CONTENT',
  FOLDERS = 'FOLDERS',
  FOLDERS_UPDATES = 'FOLDERS_UPDATES',
  SHARED_FOLDERS = 'SHARED_FOLDERS',
  ARCHIVED_FOLDERS = 'ARCHIVED_FOLDERS',
  PUBLISHER_FOLDERS = 'PUBLISHER_FOLDERS',
  PUBLISHER_SHARED_FOLDERS = 'PUBLISHER_SHARED_FOLDERS',
  PUBLISHER_ARCHIVED_FOLDERS = 'PUBLISHER_ARCHIVED_FOLDERS',
  PUBLISHER_FOLDERS_UPDATES = 'PUBLISHER_FOLDERS_UPDATES',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  INTEGRATIONS = 'INTEGRATIONS',
  SEARCH_RESULTS_PUBLISHER = 'SEARCH_RESULTS_PUBLISHER',
  FAQ = 'FAQ',
  BULLETIN = 'BULLETIN',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PROFILE = 'PROFILE',
  PROFILE_PASSWORD = 'PROFILE_PASSWORD',
  PROFILE_OFFLINE = 'PROFILE_OFFLINE',
  REPORTS = 'REPORTS',
  VIEWER_REPORTS = 'VIEWER_REPORTS',
  NOT_FOUND = 'NOT_FOUND',
  SYNC_STATUS_DEBUG = 'SYNC_STATUS_DEBUG',
  FOLDERS_UPLOADS = 'FOLDERS_UPLOADS',
  TENANT_CONFIGURATION = 'TENANT_CONFIGURATION',
  ADMIN_SETTINGS = 'ADMIN_SETTINGS',
  ADMIN_INTEGRATION_SETTINGS = 'ADMIN_INTEGRATION_SETTINGS',
  HUBS = 'HUBS',
  EDIT_HUBS = 'EDIT_HUBS',
  HUB_TEMPLATES = 'HUB_TEMPLATES',
  EDIT_HUB_TEMPLATES = 'EDIT_HUB_TEMPLATES',
  GENERAL_DEBUG = 'GENERAL_DEBUG',
  DEVICE_DEBUG = 'DEVICE_DEBUG',
  // UI2 VIEWER ROUTE
  UI2_DASHBOARD = 'UI2_DASHBOARD',
  UI2_LIBRARY = 'UI2_LIBRARY',
  UI2_FOLDERS = 'UI2_FOLDERS',
  UI2_FOLDERS_MY_FOLDERS = 'UI2_FOLDERS_MY_FOLDERS',
  UI2_FOLDERS_SHARED_WITH_ME = 'UI2_FOLDERS_SHARED_WITH_ME',
  UI2_FOLDERS_MY_UPLOADS = 'UI2_FOLDERS_MY_UPLOADS',
  UI2_FOLDERS_MY_UPDATES = 'UI2_FOLDERS_MY_UPDATES',
  UI2_FOLDERS_ARCHIVED = 'UI2_FOLDERS_ARCHIVED',
  UI2_FAVORITES_PARENT = 'UI2_FAVORITES_PARENT',
  UI2_FAVORITE_FILES = 'UI2_FAVORITE_FILES',
  UI2_FAVORITE_FOLDERS = 'UI2_FAVORITE_FOLDERS',
  UI2_MEETING_HISTORY = 'UI2_MEETING_HISTORY',
  UI2_HUBS = 'UI2_HUBS',
  UI2_ANALYTICS = 'UI2_ANALYTICS',
  UI2_NOTIFICATIONS = 'UI2_NOTIFICATIONS',
  // UI2 PUBLISHER ROUTE
  UI2_PUBLISHER_LIBRARY = 'UI2_PUBLISHER_LIBRARY',
  UI2_PUBLISHER_FOLDERS = 'UI2_PUBLISHER_FOLDERS',
  UI2_PUBLISHER_FOLDERS_MY_FOLDERS = 'UI2_PUBLISHER_FOLDERS_MY_FOLDERS',
  UI2_PUBLISHER_FOLDERS_SHARED_WITH_ME = 'UI2_PUBLISHER_FOLDERS_SHARED_WITH_ME',
  UI2_PUBLISHER_FOLDERS_MY_UPDATES = 'UI2_PUBLISHER_FOLDERS_MY_UPDATES',
  UI2_PUBLISHER_FOLDERS_ARCHIVED = 'UI2_PUBLISHER_FOLDERS_ARCHIVED',
  UI2_PUBLISHER_EMAIL_TEMPLATES = 'UI2_PUBLISHER_EMAIL_TEMPLATES',
  UI2_PUBLISHER_HUB_TEMPLATES = 'UI2_PUBLISHER_HUB_TEMPLATES',
  UI2_PUBLISHER_ANALYTICS = 'UI2_PUBLISHER_ANALYTICS',
  UI2_PUBLISHER_ADMIN = 'UI2_PUBLISHER_ADMIN',
  UI2_PUBLISHER_ADMIN_USER = 'UI2_PUBLISHER_ADMIN_USER',
  UI2_PUBLISHER_ADMIN_INTEGRATION = 'UI2_PUBLISHER_ADMIN_INTEGRATION',
  UI2_PUBLISHER_AI_BEACON = 'UI2_PUBLISHER_AI_BEACON'
}

enum AppModules {
  publisher,
  viewer
}
type AppModule = keyof typeof AppModules

export interface DeviceRouteConfigOptions {
  disableNotificaions?: boolean
  disableSearch?: boolean
  activateInfoPanel?: boolean
  disableGlobalHeader?: boolean
  disableGlobalNavigationMenu?: boolean
  disableGlobalFooter?: boolean
  disableMeetings?: boolean
  enableHorizontalScroll?: boolean
  disableNetworkStatusBanner?: boolean
  disableGlobalScroll?: boolean
  disableQuickFilters?: boolean
}

export interface BaseRouteConfigOptions {
  desktop?: DeviceRouteConfigOptions
  tablet?: DeviceRouteConfigOptions
  modules?: AppModule[]
}

export type DNARoute = {
  /** This id must be unique across all routes */
  UID: string,
  PATH: string,
  SEARCH?: string,
  LABEL: string,
  ICON?: string,
  testID?: string,
  PARENT_PATH?: string,
  ROLES?: UserRole[],
  CUSTOM_ICON?: React.FC<SvgProps>,
  ALLOWED_ROLES?: UserRole[],
  configOptions?: BaseRouteConfigOptions,
}

type Routes = Record<PAGES, DNARoute>

export const ROUTES: Routes = {
  CRM_INTEGRATION: {
    UID: 'crm-integration',
    PATH: '/profile/crm-integration',
    LABEL: 'CRM Integration',
    testID: 'crm-integration',
  },
  SSO_OIDC_START: {
    UID: 'sso-oidc-start',
    PATH: '/sso/oidc/start',
    LABEL: 'External OIDC SSO Start',
    testID: 'sso-oidc-start',
  },
  SSO_OIDC_CALLBACK: {
    UID: 'sso-oidc-callback',
    PATH: '/sso/oidc/callback',
    LABEL: 'External OIDC SSO Callback',
    testID: 'sso-oidc-callback',
  },
  HOME: {
    UID: 'home',
    PATH: '/',
    LABEL: 'Home',
    CUSTOM_ICON: HomeIcon,
    testID: 'home',
  },
  PLAYGROUND: {
    UID: 'playground',
    PATH: '/playground',
    LABEL: 'App Playground',
    testID: 'app-playground',
  },
  EMAIL_TEMPLATES: {
    UID: 'email-templates',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    CUSTOM_ICON: LetterIcon,
    PATH: '/email-templates',
    LABEL: 'Email Templates',
    testID: 'email-templates',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },
  PUBLISHER_DASHBOARD: {
    UID: 'dashboard',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    CUSTOM_ICON: LibraryIcon,
    LABEL: 'Library',
    PATH: '/publisher',
    testID: 'dashboard',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        enableHorizontalScroll: true,
      },
    },
  },
  TENANTS: {
    UID: 'tenants',
    ALLOWED_ROLES: [UserRole.ALUCIO_ADMIN],
    PATH: '/tenants',
    LABEL: 'Tenant Management',
    testID: 'tenant-management',
    configOptions: {
      desktop: {
        disableNotificaions: true,
        disableSearch: true,
        disableGlobalNavigationMenu: true,
        disableMeetings: true,
      },
      tablet: {
        disableGlobalNavigationMenu: true,
      },
    },
  },
  INTEGRATIONS: {
    UID: 'integrations',
    ALLOWED_ROLES: [UserRole.ALUCIO_ADMIN],
    PATH: '/tenants/integrations',
    LABEL: 'Integrations Management',
    testID: 'integrations-management',
    configOptions: {
      desktop: {
        disableNotificaions: true,
        disableSearch: true,
        disableMeetings: true,
        disableGlobalNavigationMenu: true,
      },
      tablet: {
        disableGlobalNavigationMenu: true,
      },
    },
  },
  TENANT_CONFIGURATION: {
    UID: 'tenant_configuration',
    ALLOWED_ROLES: [UserRole.ALUCIO_ADMIN],
    PATH: '/tenants/configuration',
    LABEL: 'Tenant Configuration',
    testID: 'tenant-configuration',
    configOptions: {
      desktop: {
        disableNotificaions: true,
        disableSearch: true,
        disableMeetings: true,
        disableGlobalNavigationMenu: true,
      },
    },
  },
  LIBRARY: {
    UID: 'library',
    PATH: '/library',
    SEARCH: '?display=list',
    LABEL: 'Library',
    CUSTOM_ICON: LibraryIcon,
    testID: 'library',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
        disableGlobalScroll: true,
      },
    },
  },
  // [TODO] - Update this to Favorites? Ensure all other routes / nav works correctly
  //        - Some of them do string checking on the label for example
  //        - Run by products if we want to also change the URL from bookmarks to favorites
  BOOKMARKS: {
    UID: 'bookmarks',
    PATH: '/bookmarks',
    SEARCH: '?display=list',
    LABEL: 'Bookmarks',
    CUSTOM_ICON: BookmarksIcon,
    testID: 'bookmarks',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  MEETING_PRESENTATION: {
    UID: 'meeting-presentation',
    PATH: '/meeting-presentation/:meetingId',
    LABEL: 'Meetings',
    testID: 'meeting-presentation',
    configOptions: {
      desktop: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
        disableGlobalFooter: true,
        disableGlobalScroll: true,
      },
      tablet: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
      },
    },
  },
  MEETING_CONTENT: {
    UID: 'meeting-content',
    PATH: '/meeting-content/:meetingId?',
    LABEL: 'Meeting Content',
    testID: 'meeting-content',
    configOptions: {
      desktop: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
        disableGlobalFooter: true,
        disableNetworkStatusBanner: true,
        disableGlobalScroll: true,
      },
      tablet: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
        disableNetworkStatusBanner: true,
        disableGlobalScroll: true,
      },
    },
  },
  MEETING_HISTORY: {
    UID: 'meetings',
    PATH: '/meetings',
    LABEL: 'Meeting History',
    CUSTOM_ICON: MeetingHistoryIcon,
    testID: 'meeting-history',
    ALLOWED_ROLES: [
      UserRole.TENANT_PUBLISHER,
      UserRole.TENANT_VIEWER,
    ],
    configOptions: {
      desktop: {
        enableHorizontalScroll: false,
      },
      tablet: {
        enableHorizontalScroll: false,
      },
    },
  },
  FOLDERS: {
    UID: 'folders',
    PATH: '/folders',
    SEARCH: '?display=list',
    LABEL: 'My Folders',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'my-folders',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
      tablet: {
        activateInfoPanel: true,
      },
    },
  },
  FOLDERS_UPDATES: {
    UID: 'folders-updates',
    PATH: '/folders/updates',
    LABEL: 'My Updates',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'my-folders-updates',
    PARENT_PATH: '/folders',
    ALLOWED_ROLES: STANDARD_ROLES,
  },
  FOLDERS_UPLOADS: {
    UID: 'folders-uploads',
    PATH: '/folders/uploads',
    LABEL: 'My Uploads',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'my-folders-uploads',
    PARENT_PATH: '/folders',
    ALLOWED_ROLES: STANDARD_ROLES,
  },
  SHARED_FOLDERS: {
    ALLOWED_ROLES: STANDARD_ROLES,
    UID: 'shared_folders',
    PATH: '/shared_folders',
    SEARCH: '?display=list',
    LABEL: 'Shared With Me',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'shared-folders',
    PARENT_PATH: '/folders',
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
      tablet: {
        activateInfoPanel: true,
      },
    },
  },
  ARCHIVED_FOLDERS: {
    UID: 'archived_folders',
    PATH: '/archived_folders',
    SEARCH: '?display=list',
    LABEL: 'Archived Folders',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'archived-folders',
    PARENT_PATH: '/folders',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
    },
  },
  PUBLISHER_FOLDERS: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'publisher_folders',
    PATH: '/publisher_folders',
    SEARCH: '?display=list',
    LABEL: 'My Folders',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'publisher-my-folders',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  PUBLISHER_SHARED_FOLDERS: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'publisher_shared_folders',
    PATH: '/publisher_shared_folders',
    SEARCH: '?display=list',
    PARENT_PATH: '/publisher_folders',
    LABEL: 'Publisher Shared With Me',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'publisher-shared-folders',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  PUBLISHER_ARCHIVED_FOLDERS: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'publisher_archived_folders',
    PATH: '/publisher_archived_folders',
    SEARCH: '?display=list',
    PARENT_PATH: '/publisher_folders',
    LABEL: 'Publisher Archived Folders',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'publisher-archived-folders',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  PUBLISHER_FOLDERS_UPDATES: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'publisher_folders_updates',
    PATH: '/publisher_folders/updates',
    LABEL: 'My Updates',
    CUSTOM_ICON: MyFoldersIcon,
    testID: 'publisher-my-folders-updates',
    PARENT_PATH: '/publisher_folders',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  SEARCH_RESULTS: {
    UID: 'search',
    PATH: '/search/:searchText/:docId?/:page?/',
    LABEL: 'Search Results for',
    testID: 'search-results',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
        disableQuickFilters: true,
      },
      tablet: {
        disableQuickFilters: true,
      },
    },
  },
  SEARCH_RESULTS_PUBLISHER: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'publisher-search',
    PATH: '/publisher-search',
    LABEL: 'Search Results for',
    testID: 'publisher-search-results',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        enableHorizontalScroll: true,
      },
    },
  },
  FAQ: {
    UID: 'faq',
    PATH: '/faq',
    LABEL: 'User Guide / FAQ',
    testID: 'user-guide',
    configOptions: {
      desktop: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
      },
      tablet: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
      },
    },
  },
  BULLETIN: {
    UID: 'bulletin',
    PATH: '/bulletin',
    LABEL: 'Bulletin',
    testID: 'bulletin',
    ALLOWED_ROLES: STANDARD_ROLES,
  },
  NOTIFICATIONS: {
    UID: 'notifications',
    PATH: '/notifications',
    LABEL: 'Notifications',
    testID: 'notifications',
  },
  PROFILE: {
    UID: 'profile',
    PATH: '/profile',
    LABEL: 'Account Profile',
    testID: 'account-profile',
  },
  PROFILE_PASSWORD: {
    UID: 'profile-password',
    PATH: '/profile/password',
    LABEL: 'Change Password',
    testID: 'profile-password',
  },
  PROFILE_OFFLINE: {
    UID: 'profile-offline',
    PATH: '/profile/offline',
    LABEL: 'Offline Settings',
    testID: 'profile-offline',
  },
  NOT_FOUND: {
    UID: '404',
    PATH: '/404',
    LABEL: 'We could not find what you were looking for',
    testID: '404',
  },
  SYNC_STATUS_DEBUG: {
    UID: 'sync-status-debug',
    PATH: '/debug/sync-status',
    LABEL: 'Sync Status Debug',
    testID: 'sync-status-debug',
  },
  REPORTS: {
    UID: 'reports',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    CUSTOM_ICON: AnalyticsIcon,
    PATH: '/reports',
    LABEL: 'Analytics',
    testID: 'reports',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        enableHorizontalScroll: true,
      },
    },
  },
  VIEWER_REPORTS: {
    UID: 'viewer_reports',
    PATH: '/analytics-viewer',
    LABEL: 'Analytics',
    CUSTOM_ICON: AnalyticsIcon,
    testID: 'viewer_reports',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  ADMIN_SETTINGS: {
    UID: 'ADMIN_SETTINGS',
    PATH: '/publisher_admin_settings',
    LABEL: 'Settings',
    testID: 'admin-settings',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        disableGlobalScroll: true,
      },
    },
    ALLOWED_ROLES: [UserRole.TENANT_ADMIN, UserRole.TENANT_PUBLISHER],
    CUSTOM_ICON: AdminSettingsIcon,
  },
  ADMIN_INTEGRATION_SETTINGS: {
    UID: 'ADMIN_INTEGRATION_SETTINGS',
    PATH: '/publisher_admin_integrations',
    LABEL: 'Admin Integration Settings',
    testID: 'admin-integration-settings',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        disableGlobalScroll: true,
      },
    },
    ALLOWED_ROLES: [UserRole.TENANT_ADMIN, UserRole.TENANT_PUBLISHER],
    CUSTOM_ICON: AdminSettingsIcon,
  },
  HUBS: {
    UID: 'hubs',
    PATH: '/hubs',
    LABEL: 'Hubs',
    testID: 'hubs',
    CUSTOM_ICON: HubsIcon,
    configOptions: {
      desktop: {
        enableHorizontalScroll: false,
      },
      tablet: {
        enableHorizontalScroll: false,
      },
    },
  },
  EDIT_HUBS: {
    UID: 'edit-hub',
    PATH: '/hubs/:hubId',
    LABEL: 'Edit Hub',
    testID: 'edit-hub',
    configOptions: {
      desktop: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
        disableGlobalFooter: true,
      },
      tablet: {
        disableGlobalHeader: true,
        disableGlobalNavigationMenu: true,
      },
    },
  },
  HUB_TEMPLATES: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'hub-templates',
    PATH: '/hub-templates',
    LABEL: 'Hub Templates',
    testID: 'hub-templates',
    CUSTOM_ICON: HubsIcon,
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },
  EDIT_HUB_TEMPLATES: {
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    UID: 'edit-hub-template',
    PATH: '/hub-templates/:hubId',
    LABEL: 'Edit Hub Template',
    testID: 'edit-hub-template',
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },
  BEACON_COPY_LINK_HOME: {
    UID: 'beacon-copy-link-home',
    PATH: '/:docId?/:page?/',
    LABEL: 'Home',
    CUSTOM_ICON: HomeIcon,
    testID: 'home-copy-link',
  },
  BEACON_COPY_LINK: {
    UID: 'beacon-copy-link',
    PATH: '/library/:docId?/:page?/',
    LABEL: 'Copy Link',
    testID: 'beacon-copy-link',
    configOptions: {
      desktop: {
        disableGlobalHeader: true,
      },
    },
  },
  BEACON_COPY_LINK_BOOKMARKS: {
    UID: 'beacon-copy-link-bookmarks',
    PATH: '/bookmarks/:docId?/:page?/',
    SEARCH: '?display=list',
    LABEL: 'Bookmarks',
    CUSTOM_ICON: BookmarksIcon,
    testID: 'beacon-copy-link-bookmarks',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  GENERAL_DEBUG: {
    UID: 'beacon-general-debug',
    PATH: '/debug/general',
    LABEL: 'Debug',
  },
  DEVICE_DEBUG: {
    UID: 'beacon-device-debug',
    PATH: '/debug/device',
    LABEL: 'Device Debug',
  },
  // UI2 VIEWER ROUTE
  UI2_DASHBOARD: {
    UID: 'dashboard',
    testID: 'dashboard',
    PATH: '/',
    LABEL: 'Dashboard',
    ICON: 'house-simple',
  },
  UI2_LIBRARY: {
    UID: 'library',
    testID: 'library',
    PATH: '/library',
    SEARCH: '?display=list',
    LABEL: 'Library',
    ICON: 'files',
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_FOLDERS: {
    UID: 'folders',
    testID: 'folders',
    PATH: '/folders',
    SEARCH: '?display=list',
    LABEL: 'Folders',
    ICON: 'folder',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
      tablet: {
        activateInfoPanel: true,
      },
    },
  },
  UI2_FOLDERS_MY_FOLDERS: {
    UID: 'folders',
    testID: 'folders',
    PATH: '/folders',
    PARENT_PATH: '/folders',
    SEARCH: '?display=list',
    LABEL: 'My Folders',
    ICON: 'folder',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
      tablet: {
        activateInfoPanel: true,
      },
    },
  },
  UI2_FOLDERS_SHARED_WITH_ME: {
    UID: 'shared_folders',
    testID: 'shared-folders',
    PATH: '/shared_folders',
    PARENT_PATH: '/folders',
    SEARCH: '?display=list',
    LABEL: 'Shared With Me',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
      tablet: {
        activateInfoPanel: true,
      },
    },
  },
  UI2_FOLDERS_MY_UPLOADS: {
    UID: 'folders-uploads',
    testID: 'my-folders-uploads',
    PATH: '/folders/uploads',
    PARENT_PATH: '/folders',
    LABEL: 'My Uploads',
    ALLOWED_ROLES: STANDARD_ROLES,

  },
  UI2_FOLDERS_MY_UPDATES: {
    UID: 'folders-updates',
    testID: 'my-folders-updates',
    PATH: '/folders/updates',
    PARENT_PATH: '/folders',
    LABEL: 'My Updates',
    ALLOWED_ROLES: STANDARD_ROLES,
  },
  UI2_FOLDERS_ARCHIVED: {
    UID: 'archived_folders',
    testID: 'archived-folders',
    PATH: '/archived_folders',
    PARENT_PATH: '/folders',
    SEARCH: '?display=list',
    LABEL: 'Archived Folders',
    ALLOWED_ROLES: STANDARD_ROLES,
    configOptions: {
      desktop: {
        activateInfoPanel: true,
      },
    },
  },
  UI2_FAVORITES_PARENT: {
    UID: 'FavoritesParent',
    testID: 'favorites-parent',
    PATH: '/favorites/files',
    LABEL: 'Favorites',
    ICON: 'star',
    ALLOWED_ROLES: [UserRole.TENANT_VIEWER, UserRole.TENANT_VIEW_ONLY],
  },
  UI2_FAVORITE_FILES: {
    UID: 'FavoriteFiles',
    testID: 'favorites-files',
    PATH: '/favorites/files',
    SEARCH: '?display=list',
    LABEL: 'Favorite Files',
    ICON: 'file',
    ALLOWED_ROLES: [UserRole.TENANT_VIEWER, UserRole.TENANT_VIEW_ONLY],
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_FAVORITE_FOLDERS: {
    UID: 'FavoriteFolders',
    testID: 'favorites-folders',
    PATH: '/favorites/folders',
    SEARCH: '?display=list',
    LABEL: 'Favorite Folders',
    ICON: 'folder',
    ALLOWED_ROLES: [UserRole.TENANT_VIEWER],
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_MEETING_HISTORY: {
    UID: 'meetings',
    testID: 'meeting-history',
    PATH: '/meetings',
    LABEL: 'Meeting History',
    ICON: 'calendar-dots',
    ALLOWED_ROLES: [
      UserRole.TENANT_VIEWER,
    ],
    configOptions: {
      desktop: {
        enableHorizontalScroll: false,
      },
      tablet: {
        enableHorizontalScroll: false,
      },
    },
  },
  UI2_HUBS: {
    UID: 'hubs',
    testID: 'hubs',
    PATH: '/hubs',
    LABEL: 'Hubs',
    ICON: 'git-fork',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER, UserRole.TENANT_VIEWER],
    configOptions: {
      desktop: {
        enableHorizontalScroll: false,
      },
      tablet: {
        enableHorizontalScroll: false,
      },
    },
  },
  UI2_ANALYTICS: {
    UID: 'viewer_reports',
    testID: 'viewer_reports',
    PATH: '/analytics-viewer',
    LABEL: 'Analytics',
    ICON: 'chart-bar',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER, UserRole.TENANT_VIEWER],
    configOptions: {
      desktop: {
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_NOTIFICATIONS: {
    UID: 'notifications',
    testID: 'notifications',
    PATH: '/notifications',
    LABEL: 'Notifications',
    ICON: 'bell',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER, UserRole.TENANT_VIEWER],
  },
  // UI2 PUBLISHER ROUTE
  UI2_PUBLISHER_LIBRARY: {
    UID: 'library',
    testID: 'library',
    PATH: '/publisher',
    LABEL: 'Library',
    ICON: 'files',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_PUBLISHER_FOLDERS: {
    UID: 'publisher_folders',
    testID: 'publisher-folders',
    PATH: '/publisher_folders',
    SEARCH: '?display=list',
    LABEL: 'Folders',
    ICON: 'folder',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  UI2_PUBLISHER_FOLDERS_MY_FOLDERS: {
    UID: 'publisher_folders',
    testID: 'publisher-folders',
    PATH: '/publisher_folders',
    SEARCH: '?display=list',
    LABEL: 'My Folders',
    ICON: 'folder',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  UI2_PUBLISHER_FOLDERS_SHARED_WITH_ME: {
    UID: 'publisher_shared_folders',
    testID: 'publisher-shared-folders',
    PATH: '/publisher_shared_folders',
    PARENT_PATH: '/publisher_folders',
    SEARCH: '?display=list',
    LABEL: 'Shared With Me',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  UI2_PUBLISHER_FOLDERS_MY_UPDATES: {
    UID: 'publisher_folders_updates',
    testID: 'publisher-my-folders-updates',
    PATH: '/publisher_folders/updates',
    PARENT_PATH: '/publisher_folders',
    LABEL: 'My Updates',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  UI2_PUBLISHER_FOLDERS_ARCHIVED: {
    UID: 'publisher_archived_folders',
    testID: 'publisher-archived-folders',
    PATH: '/publisher_archived_folders',
    PARENT_PATH: '/publisher_folders',
    SEARCH: '?display=list',
    LABEL: 'Archived Folders',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        activateInfoPanel: true,
      },
    },
  },
  UI2_PUBLISHER_EMAIL_TEMPLATES: {
    UID: 'email-templates',
    testID: 'email-templates',
    PATH: '/email-templates',
    LABEL: 'Email Templates',
    ICON: 'envelope-simple',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },
  UI2_PUBLISHER_HUB_TEMPLATES: {
    UID: 'hub-templates',
    testID: 'hub-templates',
    PATH: '/hub-templates',
    LABEL: 'Hub Templates',
    ICON: 'git-fork',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },
  UI2_PUBLISHER_ANALYTICS: {
    UID: 'reports',
    testID: 'reports',
    PATH: '/reports',
    LABEL: 'Analytics',
    ICON: 'chart-bar',
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        enableHorizontalScroll: true,
      },
    },
  },
  UI2_PUBLISHER_ADMIN: {
    UID: 'PUBLISHER_ADMIN_SETTINGS',
    testID: 'admin-settings',
    PATH: '/publisher_admin',
    LABEL: 'Settings',
    ICON: 'user-gear',
    ALLOWED_ROLES: [UserRole.TENANT_ADMIN, UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        disableGlobalScroll: true,
      },
    },
  },
  UI2_PUBLISHER_ADMIN_USER: {
    UID: 'ADMIN_SETTINGS_USER',
    testID: 'admin-settings-user',
    PATH: '/publisher_admin_user',
    LABEL: 'User Admin',
    ICON: 'user-gear',
    ALLOWED_ROLES: [UserRole.TENANT_ADMIN],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        disableGlobalScroll: true,
      },
    },
  },
  UI2_PUBLISHER_ADMIN_INTEGRATION: {
    UID: 'ADMIN_SETTINGS_INTEGRATION',
    PATH: '/publisher_admin_integration',
    LABEL: 'Integrations',
    testID: 'admin-integration-settings',
    ICON: 'user-gear',
    ALLOWED_ROLES: [UserRole.TENANT_ADMIN, UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
        disableGlobalScroll: true,
      },
    },
  },
  UI2_PUBLISHER_AI_BEACON: {
    UID: 'PUBLISHER_AI_BEACON',
    PATH: '/publisher-ai-beacon',
    LABEL: 'AI Beacon',
    testID: 'publisher-ai-beacon',
    CUSTOM_ICON: AdminSettingsIcon,
    ALLOWED_ROLES: [UserRole.TENANT_PUBLISHER],
    configOptions: {
      modules: ['publisher'],
      desktop: {
        disableMeetings: true,
      },
    },
  },

}

export const HTMLTroubleshootingPage = '/hc/en-us/articles/10172766653463--HTML-Website-Publishing-Troubleshooting-Tips'

export default ROUTES
